import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import FormContract from '../form/contract'
import {TableCECOWrapper} from './component/table/ceco'
import {TabCentralModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {useCentral} from '../../../../../../hooks/useCentral'
const CECOTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()

  const handleBack = () => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
    }
    // reset()
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('CECO/ACCESO') && <Tab className={'sdx_sub_tab_panel_option'}>CECOs</Tab>}
        </TabList>
        <TabPanel>
          <FormContract />
        </TabPanel>
        {isAllowed('CECO/ACCESO') && (
          <TabPanel>
            <TableCECOWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default CECOTab
